<template>
    <div class="container">
        <div class="d-flex align-items-center justify-content-center" v-if="loading">
            <strong>Chargement...</strong>

            <div class="spinner-grow ms-auto" role="status" aria-hidden="true">
                <span class="visually-hidden">Chargement...</span>
            </div>
        </div>

        <form id="form_tel" @submit.prevent="processTel" v-if="!loading && tel_ok">

            <div class="form-group">
                <input type="hidden" class="form-control" v-model="uuid" name="uuid" id="uuid">
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fa fa-phone"></i></span>
                    <input id="phone_check" name="phone_check" v-model="phone_check" type="text" class="form-control"
                           required="required" placeholder="Téléphone">
                </div>
                <span id="numberHelpBlock" class="form-text text-muted">Merci d'entrer votre numéro de téléphone dans le format suivant 0761231212 ou 00336123123</span>
            </div>
            <div class="form-group row mb-5">
                <div class="col-12">
                    <div class="d-grid gap-2">
                        <button name="submit" type="submit" class="btn btn-primary btn-block">Envoyer</button>
                    </div>
                </div>
            </div>
        </form>

        <form id="form_reg" @submit.prevent="processForm" v-if="!tel_ok">
            <div class="form-group">
                <input type="hidden" class="form-control" v-model="uuid" name="uuid" id="uuid">
            </div>

            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fa fa-phone"></i></span>
                    <input id="phone" name="phone" v-model="phone" type="text" class="form-control"
                           required="required" placeholder="Téléphone">
                </div>
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                    <input id="lastname" name="lastname" v-model="lastname" type="text" class="form-control"
                           placeholder="Nom" required="required">
                </div>
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                    <input id="firstname" name="firstname" v-model="firstname" type="text" class="form-control"
                           placeholder="Prénom" required="required">
                </div>
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fa fa-street-view"></i></span>
                    <input id="street" name="street" v-model="street" type="text" 
                           class="form-control" placeholder="Rue">
                </div>
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fa fa-street-view"></i></span>
                    <input id="number" name="number" v-model="number" type="text" class="form-control"
                           placeholder="Numéro" aria-label="Username"
                           aria-describedby="addon-wrapping" >
                </div>
                <!--                    <span id="numberHelpBlock" class="form-text text-muted">Number of your address</span>-->
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fa fa-street-view"></i></span>
                    <input id="zip" name="zip" v-model="zip" type="number"  class="form-control"
                           aria-describedby="zipHelpBlock"
                           placeholder="Code postal">
                </div>
                <!--<div class="input-group flex-nowrap">
                    <small id="zipHelpBlock" class="form-text text-muted">Code postal ( 1227 )</small>
                </div>-->
            </div>
            <div class="form-group py-2">
                <div class="input-group flex-nowrap">
                    <span class="input-group-text"><i class="fa fa-street-view"></i></span>
                    <input id="city" name="city" v-model="city" type="text"
                           class="form-control" placeholder="Ville">
                </div>
            </div>
            
            <div class="form-group py-2">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="acceptSaveInfo" name="acceptSaveInfo"
                           v-model="accept_save_info">
                    <label class="form-check-label" for="acceptSaveInfo">J’autorise le Café Léo à conserver mes données personnelles. (Le Café Léo s'engage à ne pas divulguer ces informations)</label>
                </div>
            </div>
            <div class="form-group row mb-5">
                <div class="col-12">
                    <div class="d-grid gap-2">
                        <button name="submit" type="submit" class="btn btn-primary btn-block">Envoyer</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "Forms",

    data() {
        return {
            tables: [],
            phones: [],
            loading: false,
            tel_ok: true,
            phone_check: "",
            uuid: this.$route.params.uuid,
            firstname: "",
            lastname: "",
            number: "",
            street: "",
            zip: "",
            city: "",
            phone: "",
            accept_save_info: true,
        }
    },
    beforeMount() {
        this.$table = this.$resource("https://cafeleo.prolibre.com/cafeleo/booking/check{/id}")
    },
    beforeRouteEnter(route, redirect, next) {
        next(vm => {
            vm.loading = true

            //vm.$table.query({id: "2c82776f-8751-41d0-9bfe-460be616136c"}).then(response => {

            vm.$table.query({id: vm.$route.params.uuid}).then(response => {
                // get body data
                vm.tables = response.body;
                //console.log(response.body);
            }, () => {
                // error callback
                next("/")
                alert("Ce QRcode n'est plus ou pas encore valide")
            }).then(() => {
                    vm.loading = false
                }
            );
        })
    },
    methods: {
        processTel: function () {
            this.item = {
                uuid: this.uuid,
                phone_check: this.phone_check,
            }
            this.$phones = this.$resource("https://cafeleo.prolibre.com/cafeleo/booking/checktel{/id}{/phone}")
            // envoie des donner
            this.$phones.query({id:this.uuid,phone: this.phone_check}).then(response => {
                console.log(response)

                // get body data
                this.phone_response = response.body;
                this.$router.push({name: 'Success'})
            }, () => {
                // error callback
                this.tel_ok = false
                this.phone = this.phone_check
            });
        },

        processForm: function () {
            this.item = {
                uuid: this.uuid,
                firstname: this.firstname,
                lastname: this.lastname,
                number: this.number,
                street: this.street,
                zip: this.zip,
                city: this.city,
                phone: this.phone,
                accept_save_info: this.accept_save_info
            }
            // envoie des donner
            this.$table.save({id: this.uuid}, {item: this.item}).then(() => {
                // success callback
                // redirect to route after successful login
                this.$router.push({name: 'Success'})
            }, () => {
                // error callback
                // redirect to route after successful login
                this.$router.push({name: 'Error'})
            });
        }
    }
}
</script>

<style scoped>

</style>